import React, { useEffect } from 'react';
import { EaseModal } from '../../../../../libs/EaseModal';
import { Text1 } from '../../../../../styles';
import { EditVendorProfileDynamicForm } from '../../Forms/EditProfileDynamicForm/index';

const EditVendorProfileModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {`${!props.vendor.is_edit ? "Edit" : "Add"} Profile`}
            </Text1>
        )
    };
    
    return (
        <EaseModal
            width={500}
            title={false}
            visible={props.visible}
            onCancel={props.toggleVendorModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <EditVendorProfileDynamicForm
                vendor={props.vendor}
                onVendorSave={props.onVendorSave}
            />
        </EaseModal>
    )
};

EditVendorProfileModal.defaultProps = {
    vendor: {}
};

export { EditVendorProfileModal };